import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["title"];
import * as React from 'react';
export default (function (_ref) {
  var title = _ref.title,
    extra = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement("svg", _extends({
      width: "50",
      height: "50",
      viewBox: "0 0 50 50"
    }, extra), title, /*#__PURE__*/React.createElement("path", {
      d: "M0 0v50h50V0zm44.409 3.165l-7.279 7.278H12.764L5.591 3.165zm-8.228 10.549v22.363H13.713v-22.36zM3.164 5.38l7.279 7.384v24.473L3.164 44.41zm2.32 41.35l7.385-7.278h24.473l7.278 7.278zm41.246-2.32l-7.279-7.384V12.764L46.73 5.59z"
    }))
  );
});